export class Constants {
  public static DefaultApiHost: string = '';//"http://178.158.210.36:8035";
  public static DefaultExternalApiHost: string = null;//"http://178.158.210.36:8035";
  //public static DefaultApiHost: string = "https://www.rizkly.com:8025";

  public static RiskSpongeMaster: string = "riskspongemaster";

  public static IMAGE_FILE_EXTENSIONS = "image/*";
  public static IMAGE_FILE_DESCRIPTION = "Allowed files: .png, .jpg, .jpeg";
  public static ATTACHMENT_FILE_EXTENSIONS = ".png,.jpg,.jpeg,.doc,.docx,.xls,.xlsx,.pdf,.ppt,.pptx,.vsd,.vsdx";
  public static ATTACHMENT_FILE_DESCRIPTION = "Allowed files: .png, .jpg, .jpeg, .doc, .docx, .xls, .xlsx, .pdf, .ppt, .pptx, .vsd, .vsdx";
  public static JSON_FILE_EXTENSIONS = ".json,application/json";
  public static JSON_FILE_DESCRIPTION = "Allowed files: .json";
  public static XML_FILE_EXTENSIONS = ".xml,text/xml,application/xml";
  public static XML_FILE_DESCRIPTION = "Allowed files: .xml";
  public static JSON_OR_XML_FILE_EXTENSIONS = ".json,.xml,application/json,text/xml,application/xml,.xls,.xlsx";
  public static JSON_OR_XML_FILE_DESCRIPTION = "Allowed files: .json, .xml, .xls, .xlsx";
}
